// client/src/components/pages/Geofencing/geofenceConfigApi.js
// API client for the LexiStar geofence versioning endpoints (M1-C;
// server/routes/geofences.js). Thin wrapper over the shared axios instance in
// services/api (cookie auth, CSRF, 401 refresh; baseURL already carries /api).
// Every helper resolves to the response BODY.
import api from '../../../services/api';

/**
 * Version history, newest first:
 * { success, available, data: GeofenceVersionV1[], count, message? }.
 * available === false when migration 021 is not applied yet.
 */
export const listGeofenceVersions = (geofenceId) =>
  api.get(`/geofences/${geofenceId}/versions`).then((res) => res.data);

/** { success, data: GeofenceVersionV1 } */
export const getGeofenceVersion = (geofenceId, version) =>
  api.get(`/geofences/${geofenceId}/versions/${version}`).then((res) => res.data);

/**
 * Entry/exit transitions the draft geometry would have produced over
 * [from, to) (ISO strings). geofenceId null = an unsaved zone. `draft` is the
 * geometry part of the save payload ({ geofenceType, coordinates } or
 * { geofenceType, latitude, longitude, radiusMeters }).
 * Resolves to { entries, exits, assets_with_events, fixes_scanned, truncated,
 * window, note, by_asset, ... }.
 */
export const testGeofenceAgainstHistory = (geofenceId, draft, { from, to }) =>
  api
    .post(`/geofences/${geofenceId ?? 'new'}/test-against-history`, draft, {
      params: { from, to },
      timeout: 120000,
    })
    .then((res) => res.data?.data);
